wbApp.factory('onlineMeetingsSvc', ['$resource', '$q', 'repositorySvc', 'tenantInfoSvc',
    function ($resource, $q, repositorySvc, tenantInfoSvc) {
        var ZoomMeetings = $resource('/restapi/zoom-meetings', {}, {
            'getInfoByDateRange': { method: 'GET', url: '/restapi/zoom-meetings/info/range', isArray: true },
            'getById': { method: 'GET', url: '/restapi/zoom-meetings/:id' },
        });

        function getInfoByDateRange(fromDateUtc, toDateUtc) {
            return repositorySvc.customGet('getInfoByDateRange', ZoomMeetings, {
                from: moment(fromDateUtc).startOf('day').toDate(),
                to: moment(toDateUtc).endOf('day').toDate(),
                expanded: 'EmployeePersonalInformation'
            });
        }

        function getById(meetingId) {
            return repositorySvc.customGet('getById', ZoomMeetings, { id: meetingId });
        }

        return {
            getById: getById,
            getInfoByDateRange: getInfoByDateRange
        }
    }
]);
